import React, { useState, useEffect } from "react";
import {
  IconButton,
  Box,
  Typography,
  Dialog,
  CircularProgress,
  Fab,
  Grid,
  Drawer,
} from "@mui/material";
import FastfoodIcon from "@mui/icons-material/Fastfood";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";

import LocalDrinkIcon from "@mui/icons-material/LocalDrink";
import DirectionsRunIcon from "@mui/icons-material/DirectionsRun";
import SportsEsportsIcon from "@mui/icons-material/SportsEsports";
import NightsStayIcon from "@mui/icons-material/NightsStay";

import ScaleIcon from "@mui/icons-material/Scale";






import { fetchHomePageData } from "../../apiservices/ApiService";
import { useNavigate } from "react-router-dom";
import CategoriesScreen from "../play/CategoriesScreen";
import StreamerProfile from "../play/StreamerProfile";






import Card130LifeStyleCard from "../../cards/Card130LifeStyleCard";
import AppNavigation from "../../navigation/AppNavigation";

import Card17Image from "../../cards/Card17Image";
import Card17Product from "../../cards/Card17Product";
import Card114EntryPoint from "../../cards/Card114EntryPoint";
import Card64Activities from "../../cards/Card64Activities";
import Card38WebCard from "../../cards/Card38WebCard";
import Card35Video from "../../cards/Card35Video";
import Card18Image from "../../cards/Card18Image";
import Card17ImageTextTime from "../../cards/Card17ImageTextTime";
import Card33VideoHorizontal from "../../cards/Card33VideoHorizontal";
import LoadingScreenBlackLogo from "../../common/LoadingProgressBar";


const GOQiiHomeScreen = () => {


  const { handleNavigation } = AppNavigation();
  const [selectedProfile, setSelectedProfile] = useState(null);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [view, setView] = useState("home");
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [cards, setCards] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [drawerOpen, setDrawerOpen] = useState(false); // For bottom drawer
  const navigate = useNavigate();
  const isInitialMount = React.useRef(true);

  const loadVideoComponents = async (pageId = 0) => {
    setIsLoading(true);
    try {
      const data = await fetchHomePageData({ pageId });
      if (data?.cards) {
        const filteredCards = data.cards.filter(
          (card) =>
            !["Graph_nutritionawareness", "Button_View_More_Insights", "Data_Food", "smart_card", "home_blogs"].includes(card.keyword)
        );
        setCards((prevCards) => [...prevCards, ...filteredCards]);
        setHasMore(filteredCards.length > 0);
      } else {
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error fetching video components:", error);
      setHasMore(false);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      loadVideoComponents(0);
    }
  }, []);

  const handleProfileClick = (profileData) => {
    setSelectedProfile(profileData);
    setView("StreamerProfile");
  };

  const handleVideoClick = (videoData) => {
    setSelectedVideo(videoData);
  };

  const handleClosePlayer = () => {
    setSelectedVideo(null);
  };

  const handleFloatingButtonClick = () => {
    setDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  const handleOptionClick = (option) => {
    console.log(`${option.label} clicked with FSN: ${option.FSN}`);

    const onTap = {
      NavigationType: "0", // Default NavigationType
      FSN: option.FSN, // Use FSN from the clicked option
      FSSN: "0",
      FAI: {
        title: option.title, // Set title dynamically based on label
      },
    };

    // If the label is "Games", add a URL
    if (option.label === "Games") {
      onTap.FAI.url = "https://gamesforgood.goqii.com/games-list?&uid=OVdxMzBGMjZnWWpqWU1URmVOazZKUT09"; // Replace with the actual URL
    }

    // Update NavigationType to "3"
    const updatedOnTap = {
      ...onTap,
      NavigationType: "3",
    };

    console.log("Updated onTap with NavigationType set to 3:", updatedOnTap);

    // Pass updated onTap to handleNavigation
    handleNavigation(updatedOnTap);

    // Close the drawer
    setDrawerOpen(false);
  };

  const renderCardsByTypeAndItem = (card) => {
    switch (card.cardType) {
      case "17":
        return card.itemType === "image-text-time" ? (
            <Card17ImageTextTime card={card} handleProfileClick={handleProfileClick} />
        ) : 
          (card.itemType === "product" || card.itemType === "upcoming-flash-sale") ? (
            <Card17Product card={card} updateCartValue={0} />
        ) : (
            <Card17Image card={card} />
        );
      case "35":
        return <Card35Video card={card} handleVideoClick={handleVideoClick} />;
      case "18":
        return <Card18Image card={card} />;
      case "33":
        return <Card33VideoHorizontal card={card} />;
      case "130":
        return <Card130LifeStyleCard card={card} />;
      case "38":
        return <Card38WebCard card={card} />;
      case "64":
        return <Card64Activities card={card} />;
      case "114":
        return <Card114EntryPoint card={card} />;
      default:
        return null;
    }
  };


  const options = [
    {
      icon: <FastfoodIcon style={{ fontSize: 40, color: "#ff5722" }} />,
      label: "Food",
      FSN: "24",
      title: "Log Food",
    },
    {
      icon: <LocalDrinkIcon style={{ fontSize: 40, color: "#2196f3" }} />,
      label: "Water",
      FSN: "26",
      title: "Log Water Intake",
    },
    {
      icon: <DirectionsRunIcon style={{ fontSize: 40, color: "#ffeb3b" }} />,
      label: "Activity",
      FSN: "23",
      title: "Log Physical Activity",
    },
    {
      icon: <SportsEsportsIcon style={{ fontSize: 40, color: "#3f51b5" }} />,
      label: "Games",
      FSN: "223",
      title: "Games4Good",
    },
    {
      icon: <NightsStayIcon style={{ fontSize: 40, color: "#607d8b" }} />,
      label: "Sleep",
      FSN: "25",
      title: "Log Sleep Duration",
    },
    {
      icon: <ScaleIcon style={{ fontSize: 40, color: "#4caf50" }} />,
      label: "Weight",
      FSN: "27",
      title: "Log Weight",
    },
  ];

  return view === "home" ? (
    <>
      <Box
        sx={{
          backgroundColor: "#f0f0f0",
          width: "100%",
          overflowX: "hidden",
          padding: 0,
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "column",
          flexGrow: 1,
        }}
      >
        {cards.map((card, idx) => (
          <Box key={idx}>{renderCardsByTypeAndItem(card)}</Box>
        ))}

        {isLoading && <LoadingScreenBlackLogo />}

        {/* Main content box */}
        <Box
          sx={{
            position: "relative",
            backgroundColor: "#f0f0f0",
            flexShrink: 1,
          }}
        >
          {/* Floating Button */}
          {!drawerOpen && (
            <Fab
              color="primary"
              sx={{
                position: "fixed",
                bottom: 16,
                left: "50%",
                transform: "translateX(-50%)",
                zIndex: 1300,
              }}
              onClick={handleFloatingButtonClick}
            >
              <AddIcon />
            </Fab>
          )}

          {/* Bottom Drawer */}
          <Drawer
            anchor="bottom"
            open={drawerOpen}
            onClose={handleDrawerClose}
            PaperProps={{
              sx: {
                borderRadius: "16px 16px 0 0",
                padding: "16px",
                backgroundColor: "#ffffff",
              },
            }}
          >
            <Grid container spacing={2} sx={{ textAlign: "center", paddingBottom: "16px" }}>
              {options.map((option, idx) => (
                <Grid item xs={4} key={idx}>
                  <Box
                    onClick={() => handleOptionClick(option)}
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    {option.icon}
                    <Typography variant="caption" sx={{ marginTop: "8px" }}>
                      {option.label}
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Drawer>
        </Box>
      </Box>

      {/* Video Player Dialog */}
      {selectedVideo && (
        <Dialog
          open={Boolean(selectedVideo)}
          onClose={handleClosePlayer}
          fullScreen
          sx={{
            "& .MuiPaper-root": {
              boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.3)",
              backgroundColor: "#000",
            },
          }}
        >
          <Box sx={{ position: "relative", height: "100%" }}>
            {isLoading && (
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  zIndex: 10,
                }}
              >
                <CircularProgress color="inherit" />
              </Box>
            )}
            <video
              controls
              autoPlay
              src={selectedVideo.streamUrl}
              style={{
                width: "100%",
                height: "100%",
              }}
            />
            <Typography
              variant="body1"
              sx={{
                position: "absolute",
                top: 16,
                left: 16,
                color: "#fff",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                padding: "8px 16px",
                borderRadius: 2,
                zIndex: 5,
              }}
            >
              {selectedVideo?.title}
            </Typography>
            <IconButton
              onClick={handleClosePlayer}
              sx={{
                position: "absolute",
                top: 16,
                right: 16,
                zIndex: 5,
                color: "#fff",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </Dialog>
      )}
    </>
  ) : view === "categories" ? (
    <CategoriesScreen
      typeId={selectedCategory?.typeId}
      type={selectedCategory?.type}
      onBack={() => setView("home")}
    />
  ) : (
    <StreamerProfile
      typeId={selectedProfile?.onTap?.FAI?.typeId}
      type={selectedProfile?.onTap?.FAI?.type}
      onBack={() => setView("home")}
    />
  );
};

export default GOQiiHomeScreen;